export default {
  methods: {
    validate () {
      if (this.$refs.form) {
        this.$refs.form.validate()
      } else {
        alert('Missing form ref!')
      }
    },
  },
}
